<skl-dialog-content-ins [isReady]="viewModel.isFormReady">
	<skl-dialog-header-ins
		[title]="'scenes.configuration.shared.document-configuration.dialog.title' | translate"
		id="sale-kind-dialog-header"
		(onClose)="onCancel()">
	</skl-dialog-header-ins>

	<ins-content>
		<skl-form-container>
			@if (viewModel.isFormReady) {
				<div
					class="grid"
					[sklValidationSource]="viewValidation"
					[skl-focus-by]>
					<div class="col-1">
						<ins-form-field
							[label]="'scenes.configuration.shared.document-configuration.dialog.form.name.label' | translate">
							<ins-input
								id="sale-kind-dialog-document-name"
								[(ngModel)]="viewModel.documentName"
								[placeholder]="'scenes.configuration.shared.document-configuration.dialog.form.name.placeholder' | translate"
								[sklValidate]="getValidationKey('name')">
							</ins-input>
						</ins-form-field>
					</div>
					@if (viewModel.isCalculationMethodVisible()) {
						<div class="col-1">
							<ins-form-field
								[label]="'scenes.configuration.shared.document-configuration.dialog.form.default-count-from.label' | translate">
								<ins-select
									id="sale-kind-dialog-calculation-method"
									display-text="label"
									[converter]="viewModel.calculationMethodsConverter"
									[(ngModel)]="viewModel.bo.model.defaultCalculationMethod"
									[sklValidate]="getValidationKey('defaultCalculationMethod')">
									@for (item of viewModel.calculationMethods; track item) {
										<ins-option
											[value]="item">
											{{ item.label }}
										</ins-option>
									}
								</ins-select>
							</ins-form-field>
						</div>
					}
					<div class="col-1">
						<ins-form-field
							[label]="'scenes.configuration.shared.document-configuration.dialog.form.default-payment-form.label' | translate">
							<ins-select
								display-text="name"
								id="sale-kind-dialog-default-payment-method"
								[converter]="viewModel.paymentMethodsConverter!"
								[(ngModel)]="viewModel.bo.model.defaultPaymentMethodId"
								[sklValidate]="getValidationKey('defaultPaymentMethodId')">
								@for (item of viewModel.paymentMethods; track item) {
									<ins-option
										[value]="item">
										{{ item.name }}
									</ins-option>
								}
							</ins-select>
						</ins-form-field>
					</div>
					<div class="col-1">
						<ins-form-field
							[label]="'scenes.configuration.shared.document-configuration.dialog.form.default-payment-term.label' | translate">
							<ins-input
								rtl="false"
								id="sale-kind-dialog-default-due-date"
								inputmode="decimal"
								[precision]="0"
								[placeholder]="'scenes.configuration.shared.document-configuration.dialog.form.default-payment-term.placeholder' | translate"
								[(ngModel)]="viewModel.bo.model.defaultDueDate"
								[sklValidate]="getValidationKey('defaultDueDate')">
							</ins-input>
							<div slot="end">{{ viewModel.getDefaultDueDateInnerLabel() }}</div>
						</ins-form-field>
					</div>
					@if (viewModel.vatMarginInvoice) {
						<div class="col-1">
							<ins-form-field
								[label]="'scenes.configuration.shared.document-configuration.dialog.form.margin-scheme-kind.label' | translate">
								<ins-select
									display-text="name"
									id="sale-kind-dialog-default-margin-scheme-id"
									[converter]="viewModel.marginSchemeKindsConverter!"
									[(ngModel)]="viewModel.bo.model.defaultMarginSchemeId"
									[sklValidate]="getValidationKey('defaultMarginSchemeId')">
									@for (item of viewModel.marginSchemeKinds; track item) {
										<ins-option
											[value]="item">
											{{ item.name }}
										</ins-option>
									}
								</ins-select>
							</ins-form-field>
						</div>
					}
					@if (viewModel.isAutoPaymentVisible()) {
						<div class="col-1">
							<ins-checkbox
								[(ngModel)]="viewModel.bo.model.automaticallyAddPayment"
								id="sale-kind-dialog-autmatically-add-payment"
								[label]="'scenes.configuration.shared.document-configuration.dialog.form.automatically-add-payment.label' | translate"
								[sklValidate]="getValidationKey('automaticallyAddPayment')">
							</ins-checkbox>
						</div>
					}
					<div class="col-1 align--medium-top">
						<ins-checkbox
							[(ngModel)]="viewModel.useCompanyTransactionLocation.value"
							id="sale-kind-dialog-use-company-transaction-location"
							[label]="'scenes.configuration.shared.document-configuration.dialog.form.transaction-location-from-company.label' | translate"
							[sklValidate]="getValidationKey('useCompanyTransactionLocation')">
						</ins-checkbox>
					</div>
					<div class="col-1">
						<ins-form-field
							[label]="'scenes.configuration.shared.document-configuration.dialog.form.transaction-location.label' | translate">
							<ins-input
								[(ngModel)]="viewModel.bo.model.customTransactionLocation"
								id="sale-kind-dialog-custom-transaction-location"
								[placeholder]="'scenes.configuration.shared.document-configuration.dialog.form.transaction-location.placeholder' | translate"
								[sklValidate]="getValidationKey('customTransactionLocation')">
							</ins-input>
						</ins-form-field>
					</div>
				</div>
			}
		</skl-form-container>
	</ins-content>

	<ins-footer class="dialog__buttons">
		<skl-button
			id="sale-kind-dialog-cancel-button"
			(click)="onCancel()">
			{{'scenes.configuration.shared.base.dialog.buttons.cancel' | translate}}
		</skl-button>
		<skl-button
			typeName="accent"
			id="sale-kind-dialog-save-button"
			[spinner]="viewModel.isSaving"
			(click)="onConfirmAsync()">
			{{'scenes.configuration.shared.base.dialog.buttons.save' | translate}}
		</skl-button>
	</ins-footer>
</skl-dialog-content-ins>